import { COOKIE_TYPE } from '@/utils/cookieUtils'
import { getDomain } from '@/utils/utils'

export const COOKIE_SETTINGS_KEY = 'COOKIE_SETTINGS'

export const defaultCookieList = [
  {
    type: COOKIE_TYPE.ESSENTIAL,
    title: 'Required Cookies', // 必须的cookie
    desc: 'These cookies are necessary to enable the basic features of this site to function, such as providing secure log-in or remembering how far you are through an order.',
    list: [],
    allow: true,
    isShow: true,
    switchModel: false,
  },
  {
    type: COOKIE_TYPE.ANALYTICAL,
    title: 'Analytical Cookies', // 数据分析相关
    desc: 'Analytical cookies track users’ activities in their browsers, so that we can better understand how our website is being accessed and used.',
    list: [],
    allow: false,
    isShow: false,
    switchModel: false,
  },
  {
    type: COOKIE_TYPE.FUNCTIONAL,
    title: 'Functional Cookies', // 功能\性能相关
    desc: 'These cookies allow us to analyze your use of the site to evaluate and improve our performance. They may also be used to provide a better customer experience on this site. For example, remembering your log-in details, saving what is in your shopping cart, or providing us information about how our site is used.',
    list: [],
    allow: false,
    isShow: false,
    switchModel: false,
  },
  {
    type: COOKIE_TYPE.ADVERTISING,
    title: 'Advertising Cookies', // 广告\营销 相关
    desc: 'These cookies are used to show you ads that are more relevant to you. We may share this information with advertisers or use it to better understand your interests. For example, Advertising Cookies may be used to share data with advertisers so that the ads you see are more relevant to you, allow you to share certain pages with social networks, or allow you to post comments on our site.',
    list: [],
    allow: false,
    isShow: false,
    switchModel: false,
  },
]

// cookiePolicy 展示的cookie 列表、默认会在种植在VUEX中
const Domain = `*${getDomain()}`
export const cookiePolicyList = [
  {
    title: 'REQUIRED COOKIES',
    list: [
      {
        Cookie: 'i18n_redirected',
        Domain,
        Description: '此cookie用于记录用户上一次访问网站使用的语言凭证',
        DescriptionEn:
          'This cookie is used to record the language credentials used by the user for the last visit to the website',
        Duration: '1year',
      },
      {
        Cookie: 'localeLang',
        Domain,
        Description: '此cookie用于记录用户上一次访问网站使用的语言凭证',
        DescriptionEn:
          'This cookie is used to record the language credentials used by the user for the last visit to the website',
        Duration: '1 months',
      },
      {
        Cookie: 'cookie_state',
        Domain,
        Description: '此cookie同意合规的用户行为',
        DescriptionEn: 'This cookie agrees to compliant user behavior',
        Duration: '180day',
      },
      {
        Cookie: 'toplupeToken',
        Domain,
        Description: '此cookie用于记录用户的登录凭证',
        DescriptionEn: `This cookie is used to record the user's login credentials`,
        Duration: '15day',
      },
      {
        Cookie: 'systemToken',
        Domain,
        Description: '此cookie用于记录用户的登录凭证',
        DescriptionEn: `This cookie is used to record the user's login credentials`,
        Duration: '15day',
      },
      {
        Cookie: 'loginTime',
        Domain,
        Description: '此cookie用于记录用户的登录凭证',
        DescriptionEn: `This cookie is used to record the user's login credentials`,
        Duration: '15day',
      },
      {
        Cookie: '_location',
        Domain,
        Description: '此cookie用于记录域名路径',
        DescriptionEn: `This cookie is used to record the domain name path`,
        Duration: 'session',
      },
      {
        Cookie: 'fromPath',
        Domain,
        Description: '此cookie用于记录页面来源',
        DescriptionEn: 'This cookie is used to record the origin of the page',
        Duration: 'session',
      },
      {
        Cookie: 'toPath',
        Domain,
        Description: '此cookie用于记录页面来源',
        DescriptionEn: 'This cookie is used to record the origin of the page',
        Duration: 'session',
      },
      {
        Cookie: 'isFromPayPage',
        Domain,
        Description: '此cookie用于记录页面来源',
        DescriptionEn: 'This cookie is used to record the origin of the page',
        Duration: 'session',
      },
      {
        Cookie: 'prevRef',
        Domain,
        Description: '此cookie用于记录页面来源',
        DescriptionEn: 'This cookie is used to record the origin of the page',
        Duration: 'session',
      },
      {
        Cookie: 'AKA_A2',
        Domain,
        Description:
          '此 cookie 是 Akamai 缓存功能所必需的。网站使用缓存来优化访问者和网站之间的响应时间。缓存通常存储在访问者的浏览器中。此 cookie 用于 Akamais 高级加速功能，该功能支持 DNS 预取和 HTTP2 推送。',
        DescriptionEn: `This cookie is required for Akamai's caching functionality. Websites use caching to optimize the response time between the visitor and the website. The cache is usually stored in the visitor's browser. This cookie is used for the Akamais Advanced Acceleration feature, which supports DNS prefetching and HTTP2 push.`,
        Duration: '1 day',
      },
      {
        Cookie: 'clientToken',
        Domain,
        Description: '根据设备、浏览器生成的随机id，用于获取网站展示内容',
        DescriptionEn: `This cookie is a randomly generated string  and used to differentiate devices accessed to our website`,
        Duration: '3 months',
      },
      {
        Cookie: 'showMem',
        Domain,
        Description: '用于进行业务拦截',
        DescriptionEn: `for business interception`,
        Duration: 'session',
      },
    ],
  },
  {
    title: 'ANALYTICAL COOKIES',
    list: [
      {
        Cookie: '_ga',
        Domain,
        Description: '此Cookie用于是Google Analytics标记用户。',
        DescriptionEn:
          'This cookie is used to tag users with Google Analytics.',
        Duration: '1 day',
      },
      {
        Cookie: '_gaexp',
        Domain,
        Description: '此Cookie用于Google Analytics存储A/B测试试验和会话ID',
        DescriptionEn:
          'This cookie is used by Google Analytics to store A/B test trials and session IDs',
        Duration: '3 months',
      },
      {
        Cookie: '_ga_<container-id>',
        Domain,
        Description:
          '这些 cookie 与谷歌分析相关联。这些 cookie 用于通过分配一个随机生成的数字作为客户标识符来区分唯一用户。此信息用于编制报告并帮助改进网站。Cookie 以不直接识别个人身份的方式收集信息，包括网站访问者的数量、访问者的来源以及他们访问过的页面。要了解更多信息，请阅读 Google 关于隐私和数据保护的演示文稿。',
        DescriptionEn: `These cookies are associated with Google Analytics. These cookies are used to distinguish unique users by assigning a randomly generated number as a client identifier. This information is used to compile reports and to help improve the website. Cookies collect information in a way that does not directly identify an individual, including the number of website visitors, the source of visitors and the pages they have visited. To learn more, read Google's presentation on privacy and data protection.`,
        Duration: '2years',
      },
      {
        Cookie: '_gat',
        Domain,
        Description:
          '这些 cookie 与谷歌分析相关联。这些 cookie 用于通过分配一个随机生成的数字作为客户标识符来区分唯一用户。此信息用于编制报告并帮助改进网站。Cookie 以不直接识别个人身份的方式收集信息，包括网站访问者的数量、访问者的来源以及他们访问过的页面。要了解更多信息，请阅读 Google 关于隐私和数据保护的演示文稿。',
        DescriptionEn: `These cookies are associated with Google Analytics. These cookies are used to distinguish unique users by assigning a randomly generated number as a client identifier. This information is used to compile reports and to help improve the website. Cookies collect information in a way that does not directly identify an individual, including the number of website visitors, the source of visitors and the pages they have visited. To learn more, read Google's presentation on privacy and data protection.`,
        Duration: '1 h',
      },
      {
        Cookie: '_gid',
        Domain,
        Description:
          '这些 cookie 与谷歌分析相关联。这些 cookie 用于通过分配一个随机生成的数字作为客户标识符来区分唯一用户。此信息用于编制报告并帮助改进网站。Cookie 以不直接识别个人身份的方式收集信息，包括网站访问者的数量、访问者的来源以及他们访问过的页面。要了解更多信息，请阅读 Google 关于隐私和数据保护的演示文稿。',
        DescriptionEn: `These cookies are associated with Google Analytics. These cookies are used to distinguish unique users by assigning a randomly generated number as a client identifier. This information is used to compile reports and to help improve the website. Cookies collect information in a way that does not directly identify an individual, including the number of website visitors, the source of visitors and the pages they have visited. To learn more, read Google's presentation on privacy and data protection.`,
        Duration: '1 day',
      },
      {
        Cookie: 'tt_webid',
        Domain: '*.tiktok.com',
        Description: '被社交媒体平台 TikTok 用于跟踪嵌入式服务的使用。',
        DescriptionEn: `Used by social media platform TikTok to track usage of embedded services.`,
        Duration: '1 year',
      },
      {
        Cookie: 'ttwid',
        Domain: '*.tiktok.com',
        Description:
          '被社交媒体平台 TikTok 用于跟踪嵌入式服务的使用被社交媒体平台 TikTok 用于跟踪嵌入式服务的使用。',
        DescriptionEn: `Used by social media platform TikTok to track usage of embedded services.`,
        Duration: '1 year',
      },
      {
        Cookie: 'tt_webid_v2',
        Domain: '*.tiktok.com',
        Description: '被社交媒体平台 TikTok 用于跟踪嵌入式服务的使用。',
        DescriptionEn: `Used by social media platform TikTok to track usage of embedded services.`,
        Duration: '1 year',
      },
      {
        Cookie: 'tt_sessionId',
        Domain: '*.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '',
      },
      {
        Cookie: 'tt_appInfo',
        Domain: '*.tiktok.com',
        Description: '提供用户设备信息',
        DescriptionEn: `Provide user device information`,
        Duration: '',
      },
      {
        Cookie: 'passport_csrf_token_default',
        Domain: '.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '60 days',
      },
      {
        Cookie: 'passport_csrf_token',
        Domain: '.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '60 days',
      },
      {
        Cookie: '_abck',
        Domain: '.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '1 year',
      },
      {
        Cookie: 'tt_csrf_token',
        Domain: '.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '1 day',
      },
      {
        Cookie: 'ak_bmsc',
        Domain: '.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '1 day',
      },
      {
        Cookie: 'bm_sz',
        Domain: '.tiktok.com',
        Description: '用于跟踪用户单次访问的详细信息',
        DescriptionEn: `Details for tracking a user's single visit`,
        Duration: '1 day',
      },
    ],
  },
  {
    title: 'ADVERTISING COOKIES',
    list: [
      {
        Cookie: '_fbp',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '3 months',
      },
      {
        Cookie: 'fr',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '3 months',
      },
      {
        Cookie: '_fbc',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '3 months',
      },
      {
        Cookie: 'xs',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '3 months',
      },
      {
        Cookie: 'c_user',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '1years',
      },
      {
        Cookie: 'datr',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '2years',
      },
      {
        Cookie: 'sb',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '2years',
      },
      {
        Cookie: 'wd',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '1week',
      },
      {
        Cookie: 'presence',
        Domain: 'facebook.com',
        Description:
          '这些cookies允许我们根据用户在我们网站上的浏览习惯，在Facebook上放置与用户相关的广告内容。	',
        DescriptionEn:
          'These cookies allow us to place advertising content relevant to the user on Facebook based on their browsing habits on our website. ',
        Duration: '1 months',
      },
      {
        Cookie: 'tta_attr_id',
        Domain: '.tiktok.com',
        Description:
          '被 TikTok 用于投放一系列广告产品，例如来自第三方广告商的实时竞价。',
        DescriptionEn:
          'Used by TikTok to deliver a series of advertisement products such as real time bidding from 3rd party advertisers.',
        Duration: '1 year',
      },
      {
        Cookie: 'tta_attr_id_mirror',
        Domain: '.tiktok.com',
        Description:
          '被 TikTok 用于投放一系列广告产品，例如来自第三方广告商的实时竞价。',
        DescriptionEn:
          'Used by TikTok to deliver a series of advertisement products such as real time bidding from 3rd party advertisers.',
        Duration: '1 year',
      },
      {
        Cookie: 'part',
        Domain: '.tiktok.com',
        Description:
          '被 TikTok 用于投放一系列广告产品，例如来自第三方广告商的实时竞价。',
        DescriptionEn:
          'Used by TikTok to deliver a series of advertisement products such as real time bidding from 3rd party advertisers.',
        Duration: '1 year',
      },
    ],
  },
]
